import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';

/**
 * A Content Vault item's "Sell in store" state (creator only).
 * - private:  never listed — only usable in the creator's own games
 * - draft:    creator wants it for sale, but their shop isn't ready (see blocked_reason)
 * - in_store: for sale
 * - hidden:   creator stopped selling; past buyers keep access
 */
export interface ContentStoreState {
  state: 'private' | 'draft' | 'in_store' | 'hidden';
  price: string | null;
  listing_id: number | null;
  blocked_reason: 'terms_required' | 'payouts_required' | null;
  /** Whether the item can be put on sale (always true now: the in-app store is the only store). */
  store_enabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class ContentStoreService {
  private apiUrl = serviceurl + 'api/v1/content';

  constructor(private http: HttpClient) {}

  get(contentId: number): Observable<ContentStoreState> {
    return this.http.get<ContentStoreState>(`${this.apiUrl}/${contentId}/store/`);
  }

  /** Start or stop selling; `price` omitted keeps the item's current price. */
  set(contentId: number, sell: boolean, price?: number | string | null): Observable<ContentStoreState> {
    const body: Record<string, unknown> = { sell };
    if (price !== undefined && price !== null && price !== '') {
      body['price'] = price;
    }
    return this.http.post<ContentStoreState>(`${this.apiUrl}/${contentId}/store/`, body);
  }
}
